var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTracket1 = function SvgTracket1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#fff",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5A32FA",
    d: "m18.985 27.28-2.073 3.561a10 10 0 0 1-3.276-3.306l3.542-2.027a5.9 5.9 0 0 0 1.807 1.773M21.83 28.166v4.128c-1.657-.05-3.152-.464-4.53-1.226l2.075-3.564a5.9 5.9 0 0 0 2.455.662M30.523 17.354l-3.506 2.005a5.9 5.9 0 0 0-1.813-1.86l2.054-3.516a9.9 9.9 0 0 1 3.265 3.371M26.805 31.06a9.75 9.75 0 0 1-4.525 1.231v-4.125a5.9 5.9 0 0 0 2.453-.662zM30.46 27.527a9.95 9.95 0 0 1-3.267 3.306l-2.069-3.552a5.9 5.9 0 0 0 1.805-1.774zM31.88 22.684a9.9 9.9 0 0 1-1.197 4.452l-3.522-2.016a5.8 5.8 0 0 0 .692-2.436zM31.884 22.237H27.86a5.8 5.8 0 0 0-.624-2.48l3.507-2a9.9 9.9 0 0 1 1.14 4.48M21.152 12.53v1.799c0 1.18-.96 2.14-2.141 2.14h-2.773v5.064c0 .274.018 1.032.018 1.032.023.431.07.789.148 1.125.118.505.3.986.545 1.433l-3.537 2.023a9.8 9.8 0 0 1-1.198-4.593V16.47h-1.88A1.334 1.334 0 0 1 9 15.136V12.53h3.213v-2.228L16.238 8v4.53z"
  })));
};
export default SvgTracket1;